import React from 'react';
import './App.scss';
import { Fragment } from 'react';
import Rotas from './routes'

const App = () => {
  return (
    <Fragment>
      <Rotas />
    </Fragment>
  );
}

export default App;
